export const INVALID_TRYTES = 'Invalid trytes'
export const INVALID_TRITS = 'Invalid trits'
export const INVALID_ODD_LENGTH = 'Invalid trytes length. Expected trytes of even length.'
export const INVALID_ASCII_CHARS = 'Invalid ascii charactes.'
